export default __webpack_public_path__ + "static/media/declinedIcon.3b59561a.svg";